/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityAssetsDomainDnsRecordAnswer
 */
export interface ControlEntityAssetsDomainDnsRecordAnswer {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetsDomainDnsRecordAnswer
     */
    answer?: string;
}

/**
 * Check if a given object implements the ControlEntityAssetsDomainDnsRecordAnswer interface.
 */
export function instanceOfControlEntityAssetsDomainDnsRecordAnswer(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityAssetsDomainDnsRecordAnswerFromJSON(json: any): ControlEntityAssetsDomainDnsRecordAnswer {
    return ControlEntityAssetsDomainDnsRecordAnswerFromJSONTyped(json, false);
}

export function ControlEntityAssetsDomainDnsRecordAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityAssetsDomainDnsRecordAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'answer': !exists(json, 'answer') ? undefined : json['answer'],
    };
}

export function ControlEntityAssetsDomainDnsRecordAnswerToJSON(value?: ControlEntityAssetsDomainDnsRecordAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'answer': value.answer,
    };
}

